
/*
*   根据最后一级获取经纬度
*/
function getLocationcenter(country, elemId, lnglats) {
    AMap.plugin("AMap.Geocoder", function () {
        const geocoder = new AMap.Geocoder({
            // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
            city: "全国"
        });
        geocoder.getLocation(country, (status, result) => {
            if (status === "complete" && result.info === "OK") {
                // result中对应详细地理坐标信息
                let mapCenter = [
                    result.geocodes[0].location.lng,
                    result.geocodes[0].location.lat
                ];
                var map = new AMap.Map(elemId, {
                    zoomEnable: true,
                    zoom: 11, //级别
                    center: mapCenter, //中心点坐标
                    viewMode: "3D" //使用3D视图
                });

                if (lnglats) {
                    var infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) });
                    let areaData = [];
                    areaMessage.subPlaces.map((item, index) => {
                        if (item.longitude && item.latitude) {
                            areaData.push(item);
                        }
                    })
                    for (var i = 0, marker; i < lnglats.length; i++) {
                        var marker = new AMap.Marker({
                            position: lnglats[i],
                            map: map
                        });
                        marker.id = areaData[i].id;
                        marker.content =
                            "<div>基地：" + areaData[i].name + "</div><div>地址：" + areaData[i].address + "</div><div>电话：" + areaData[i].contactsTel + "</div><div>负责人：" + areaData[i].principalName;
                        marker.on("click", markerClick);
                    }

                    function markerClick(e) {
                        infoWindow.setContent(e.target.content);
                        infoWindow.open(map, e.target.getPosition());

                        $.ajax({
                            type: 'get',
                            url: '/product/areaProduct',
                            data: {
                                "baseId": e.target.id,
                            },
                            success: function (response) {
                                if (response && (response.errno == 0) && response.data) {
                                    var str = "";
                                    $.each(response.data, function (key, value) {
                                        
                                        str += '<div style="margin:20px 20px 20px 50px">' + 
                                                  '<div style="display:inline-block;vertical-align:top;margin-right: 25px;">' + 
                                                    '<img style="width:51px;height:51px" src="' + (value.picUrl ? (typeof (value.picUrl) === 'string' ? value.picUrl : value.picUrl[0]) : '') + '"/>' + 
                                                  '</div>' +
                                                '<div style="display:inline-block;line-height:26px;width:240px">' + 
                                                  '<div style="display:inline-block;font-size:15px;font-weight:bold">' + value.name +'</div>' +
                                                  '<div style="font-size:12px">'+ value.organizationFullName +'</div>' + 
                                                '</div>' + 
                                            '</div>';

                                        $('#areaProduct').html(str);
                                    });
                                }
                                else {
                                }
                            }
                        })

                    }

                    map.setFitView();
                }
            }
        });
    });
}
function setLocationCenter(longitude, latitude, elemId) {
  const map = new AMap.Map(elemId);
  map.setCenter([longitude, latitude]);
}

function productMapInit() {
  let country;
  let locationText;

  if ($(".product-detail-mobile .content-area-map").length > 0){
    country = $(".product-detail-mobile .content-area-map").attr("data");
    if (!country) {
      locationText = $('.product-detail-mobile #contentAreaMap').attr("location");
    }
  } else {
    country = $('#country').text();
    if (!country) {
      locationText = $('#countryLocation').text();
    }
  }
  if (country) {
    getLocationcenter(country, "contentAreaMap");
  } else if (locationText && locationText.length > 2) {
    const [longitude, latitude] = locationText.split(',');
    setLocationCenter(longitude, latitude, 'contentAreaMap');
  }
}

function mapInit() {
    let regNumber = /\d+/;
    var index = location.href.lastIndexOf("/");
    let obj = location.href.substring(index + 1, location.href.length);
    if (location.href.indexOf("area") >= 0 && regNumber.test(obj)) {
        var country = $('#country').text();
        if ($(".area-detail-mobile .area-introduce .map-introduce .area-content-mobile .map-content").length > 0){
            country = $(".area-detail-mobile .area-introduce .map-introduce .area-content-mobile .map-content").attr("data");
        }
        let lnglats = [];
        areaMessage && areaMessage.subPlaces && areaMessage.subPlaces.map((item, index) => {
            if (item.longitude && item.latitude) {
                lnglats.push([item.longitude, item.latitude]);
            }
        })
        getLocationcenter(country, "mapContainer", lnglats);
    }
}

/**
 * 手机端 产品详情 点赞 事件响应
 */
function onClickedMobileStar(){
    var strProductID = $(".product-detail-mobile").attr("id");
    $.ajax({
        type:'POST',
        url: '/product/star',
        data:{
            "productID":strProductID
        },
        success:function (response){
            if (response && (response.errno == 0) && response.data && response.data.result){
                var eleDiv = $(".product-detail-mobile .title-detail .product-star #star span");
                var star = eleDiv.html();
                eleDiv.html(++star);
            }
            else {
            }
        }
    } );
}
/**
 * 手机端 产品详情 反点赞 事件响应
 */
function onClickedMobileUnstar(){
    var strProductID = $(".product-detail-mobile").attr("id");
    $.ajax({
        type:'POST',
        url: '/product/unstar',
        data:{
            "productID":strProductID
        },
        success:function (response){
            if (response && (response.errno == 0) && response.data && response.data.result){
                var eleDiv = $(".product-detail-mobile .title-detail .product-star #unstar span");
                var star = eleDiv.html();
                eleDiv.html(++star);
            }
            else {
            }
        }
    } );
}
/**
 * 手机端 产品详情 登录 事件响应
 */
function onClickedMobileLogin(){
    window.loginDialog.show();
}
const init = () => {
    productMapInit();
    mapInit();
    // 手机端
    if ($(".product-detail-mobile .title-detail .product-star").length > 0){
        // 点赞
        $(".product-detail-mobile .title-detail .product-star #star").on("click", onClickedMobileStar);
        $(".product-detail-mobile .title-detail .product-star #unstar").on("click", onClickedMobileUnstar);
        $(".product-detail-mobile .product-detail .product-detail-mobile a").on("click", onClickedMobileLogin);
    }
    else {
        $(".main .content-wrap .content .product-detail-content .introduce .right .price-area div span #btn-id-login").on("click", function (){
            window.loginDialog.show();
        });
    }
};
module.exports = { init };
